"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleDisableCommand = exports.scheduleEnableCommand = exports.scheduleDisableAllForSubscriptionCommand = exports.scheduleDeleteCommand = exports.ScheduleManagementCommands = void 0;
const Command_1 = require("./Command");
var ScheduleManagementCommands;
(function (ScheduleManagementCommands) {
    ScheduleManagementCommands["CreatePreview"] = "schedule/create/preview";
    ScheduleManagementCommands["Delete"] = "schedule/delete";
    ScheduleManagementCommands["Disable"] = "schedule/disable";
    ScheduleManagementCommands["Enable"] = "schedule/enable";
    ScheduleManagementCommands["DisableAllForSubscription"] = "schedule/disableAllForSub";
})(ScheduleManagementCommands = exports.ScheduleManagementCommands || (exports.ScheduleManagementCommands = {}));
function scheduleDeleteCommand(options) {
    const data = Object.assign({ command: ScheduleManagementCommands.Delete }, options);
    return new Command_1.Command(data);
}
exports.scheduleDeleteCommand = scheduleDeleteCommand;
const scheduleDisableAllForSubscriptionCommand = (subscriptionId) => {
    const data = {
        command: ScheduleManagementCommands.DisableAllForSubscription,
        subscriptionId,
    };
    return new Command_1.Command(data);
};
exports.scheduleDisableAllForSubscriptionCommand = scheduleDisableAllForSubscriptionCommand;
const scheduleEnableCommand = (scheduleId) => {
    const data = {
        scheduleId,
        command: ScheduleManagementCommands.Enable,
    };
    return new Command_1.Command(data);
};
exports.scheduleEnableCommand = scheduleEnableCommand;
const scheduleDisableCommand = (scheduleId) => {
    const data = {
        scheduleId,
        command: ScheduleManagementCommands.Disable,
    };
    return new Command_1.Command(data);
};
exports.scheduleDisableCommand = scheduleDisableCommand;
//# sourceMappingURL=ScheduleManagementCommands.js.map